import * as React from 'react';
import { get } from 'lodash';

import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { itemStateEnum } from '@modules/operationalWarehouse/_operationalWarehouseEnums';

export const myRequestsColumns = [
  {
    label: 'Počet předmětů',
    field: 'items',
    type: ColumnType.JSX,
    jsx: ({ row }) => <div>{row.items.length}</div>,
    width: 150
  },
  {
    label: 'Platná do',
    field: 'validUntil',
    type: ColumnType.DATE,
    width: 150
  },
  {
    label: 'Vydáno od',
    field: 'issuedFromWarehouse.name',
    displayField: 'issuedFromWarehouse',
    mapper: o => get(o, 'name'),
    type: ColumnType.TEXT,
    width: 150
  }
];

export const requestColumns = [
  ...myRequestsColumns,
  {
    label: 'Vydáno strážníkovi',
    field: 'recipient',
    type: ColumnType.TEXT,
    mapper: o => get(o, 'fullName'),
    width: 150
  }
];

export const itemsColumns = [
  {
    label: 'Název',
    field: 'name',
    type: ColumnType.TEXT,
    width: 150
  },
  {
    label: 'Kategorie',
    field: 'category.name',
    displayField: 'category',
    mapper: parent => get(parent, 'name'),
    type: ColumnType.TEXT,
    width: 150
  },
  {
    label: 'Stav předmětu',
    field: 'state',
    type: ColumnType.ENUM,
    enum: itemStateEnum,
    width: 150
  }
];



// WEBPACK FOOTER //
// ./src/modules/requests/_requestsColumns.tsx